import React from "react";

export const GoogleMeeting = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 911.458 750"
  xmlSpace="preserve"
  width   = {props.width || "28"}
  height  = {props.width || "28"}
  fill    = {props.color || "#fff"}
  {...props}
  >
  <path
    fill="#00832D"
    d="m515.625 375 88.854 101.562 119.479 76.354 20.833-177.24-20.833-173.333-121.771 67.083L515.625 375z"
  />
  <path
    fill="#0066DA"
    d="M0 536.458V687.5C0 722.031 27.969 750 62.5 750h151.042l31.25-114.167-31.25-99.375-103.646-31.25L0 536.458z"
  />
  <path
    fill="#E94235"
    d="M213.542 0 0 213.542l109.896 31.25 103.646-31.25 30.729-98.073L213.542 0z"
  />
  <path fill="#2684FC" d="M213.542 213.542H0v322.917h213.542V213.542z" />
  <path
    fill="#00AC47"
    d="M860.365 90.417 723.958 202.344v350.573l136.98 112.343c20.521 16.042 50.521 1.406 50.521-24.635V114.583c-.001-26.406-30.678-40.885-51.094-24.166z"
  />
  <path
    fill="#00AC47"
    d="M515.625 375v161.458H213.542V750h447.917c34.531 0 62.5-27.969 62.5-62.5V552.917L515.625 375z"
  />
  <path
    fill="#FFBA00"
    d="M661.458 0H213.542v213.542h302.083V375l208.333-172.656V62.5c0-34.531-27.968-62.5-62.5-62.5z"
  />
  </svg>
)